<template>
  <span>
    <FlagIcon class="tw-mr-2" :country="datacenter.region.countryCode.toLowerCase()" />
    {{ datacenter.name }}
  </span>
</template>

<script lang="ts">
import type { Datacenter } from 'gpcore-grpc/gpcore/api/cloud/v1/region_pb';
import { type PropType } from 'vue';
import FlagIcon from './new/FlagIcon.vue';

export default {
  props: {
    datacenter: {
      type: Object as PropType<Datacenter>,
      required: true,
    },
  },
  components: { FlagIcon },
};
</script>
